/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import { Cell } from "react-table";
import { FlexContainer, Text, theme, SVGIcon } from "@nordcloud/gnui";
import { CostCell } from "~/components";
import { PROVIDER_ICON_COLUMN } from "~/components/Tables/Columns";
import { ParseResourceType } from "~/components/Tables/Tools/ResourceTypeParser";
import { SUCCESS_TEXT } from "~/constants";
import { EstateRecordRow } from "~/models/estateRecordRow";
import { showSimpleInfo } from "~/services/toast";
import { trimTextBeginning } from "~/tools";

export const EnvironmentDetailsColumns = [
  PROVIDER_ICON_COLUMN,
  {
    Header: "Type",
    accessor: "providerType",
    width: "8rem",
    disableSortBy: true,
    Cell: ({ row }: Cell<EstateRecordRow>) => {
      const [family, rest] = ParseResourceType(
        row.original.providerType || row.original.type || ""
      );
      return (
        <>
          <Text size="md" tag="div" style={{ wordBreak: "break-all" }}>
            {family}
          </Text>
          <Text
            size="sm"
            tag="div"
            style={{ wordBreak: "break-all" }}
            color={theme.color.text.text02}
          >
            {rest}
          </Text>
        </>
      );
    },
  },
  {
    Header: "Resource Name / MCA ID",
    accessor: "nordcloudId",
    disableSortBy: true,
    Cell: ({ row }: Cell<EstateRecordRow>) => (
      <>
        <FlexContainer>
          <Link to={`/estate/${row.original.id}`}>
            {trimTextBeginning(
              row.original.name || row.original.providerId,
              70
            )}{" "}
          </Link>
          <CopyToClipboard
            text={row.original.providerId}
            onCopy={() => {
              showSimpleInfo(SUCCESS_TEXT.copied);
            }}
          >
            <SVGIcon
              name="copy"
              css={{ cursor: "pointer", marginLeft: theme.spacing.spacing02 }}
            />
          </CopyToClipboard>
        </FlexContainer>
        {row.original.id && (
          <FlexContainer>
            <Text size="sm" tag="span" color={theme.color.text.text02}>
              {trimTextBeginning(row.original.id, 100)}
            </Text>
            <CopyToClipboard
              text={row.original.id}
              onCopy={() => {
                showSimpleInfo(SUCCESS_TEXT.copied);
              }}
            >
              <SVGIcon
                name="copy"
                css={{ cursor: "pointer", marginLeft: theme.spacing.spacing02 }}
              />
            </CopyToClipboard>
          </FlexContainer>
        )}
      </>
    ),
  },
  {
    Header: "Region",
    accessor: "region",
    disableSortBy: true,
    width: "6rem",
    Cell: ({ row }: Cell<EstateRecordRow>) => (
      <Text size="sm" tag="span" color={theme.color.text.text02}>
        {row.original.region}
      </Text>
    ),
  },
  {
    Header: "Monthly Cost",
    accessor: "actualCosts",
    disableSortBy: true,
    width: "8rem",
    Cell: ({ row }: Cell<EstateRecordRow>) => {
      return (
        <CostCell
          isWaste={row.original?.cloudWaste?.isWaste || row.original?.isWaste}
          value={row?.original?.cost?.currentMonth}
          reason={row.original?.cloudWaste?.reason || row.original?.reason}
        />
      );
    },
  },
];
